import { useSidebarMenu } from "@/components/ui/layout/menuSidebar/sidebar"
import { cn } from "@/modules/lib/utils"
import { LogoHustleUpSmall } from "@images/logoHustleUpSmall"
import { LogoHustleUpText } from "@images/logoHustleUpText"

export function LogoHeader() {
  const { open } = useSidebarMenu()

  return (
    <div
      className={cn(
        "mt-6 flex w-full items-start justify-center gap-2 overflow-hidden p-3 transition-discrete duration-400 ease-out",
        { "w-[calc(var(--sidebar-icon-width)+--spacing(3)*2)] justify-start": !open },
      )}
    >
      <LogoHustleUpSmall color="currentColor" className="w-(--sidebar-icon-width) min-w-(--sidebar-icon-width)" />
      {open && <LogoHustleUpText color="currentColor" className="w-[93px] min-w-[93px]" />}
    </div>
  )
}
